export default __webpack_public_path__ + "static/media/3.e9c32cdc.svg";